import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";



import ModalComponent from "../ModalComponent";
import Toast from "../../helpers/Toast";
import { GetDocNumberDTO } from "../../models/Assistance/GetDocNumberDTO";
import { AssistanceService } from "../../services/AssistanceService";
import SearchSelectComponent, { SelectItemsProps } from "../SearchSelectComponent";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ButtonComponent from "../ButtonComponent";
import { Parameter } from "../../models/Parameter";

type Props = {
  isOpen: boolean;
  toggle: () => void;
  onSelect: (assistance: SelectItemsProps) => void;
  clientErpId: string;
};

export default function SelectAssistanceModal({ isOpen, toggle, onSelect, clientErpId }: Props) {
  const intl = useIntl();
  const service = new AssistanceService();
  const [selected, setSelected] = useState<SelectItemsProps | null>(null);

  useEffect(() => {
    if (isOpen) {
      setSelected(null);
    }
  }, [isOpen]);
  const loadOptions = async (input: string) => {
    if (!clientErpId) {
      Toast.Show("error", intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.WithoutClientErpId" }));
      return [];
    }
    try {
      const params: Parameter[] = [
      new Parameter("numDoc", input),
      new Parameter("clientErpId", clientErpId),
    ];
      
      
      const resp = await service.GetAll(params, [], 1, 10);
      if (!resp.success || !resp.items) {
        Toast.Show("error", resp.message);
        return [];
      }
      const list: SelectItemsProps[] = [];
        resp.items?.forEach((element) => {
            const item: SelectItemsProps = {
                value: element.assistanceId?.toString() ?? "",
                label: element.docType + " " + element.serie.toString() + " " + element.number.toString(),
              };
            list.push(item);
        });     
        
        return list;
    } catch (e) {
      Toast.Show("error", intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.Error" }));
      return [];
    }
  };
  const handleConfirm = () => {
    if (!selected) {
      Toast.Show("error", intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.Empty.Error" }));
      return;
    }
    onSelect(selected);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <FormattedMessage id="Screens.ClientQuotation.ChooseAssistance.Title" />
      </ModalHeader>
      <ModalBody>
        <SearchSelectComponent
          xl={12} lg={12} md={12} sm={12} xs={12}
          label={intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.Label" })}
          loadOptions={loadOptions}
          value={selected}
          onChange={setSelected}
        />
      </ModalBody>
      <ModalFooter>
        <ButtonComponent
          text={intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.Button.Cancel" })}
          onClick={toggle}
        />
        <ButtonComponent
          text={intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.Button.Confirm" })}
          onClick={handleConfirm}
        />
      </ModalFooter>
    </Modal>
  );
}
